import { ISearchableProperty } from '.';

export const diProperties: ISearchableProperty[] = [
  { value: 'requestId', label: 'Request ID', searchable: true },
  { value: 'reqType', label: 'Request Type', searchable: true },
  { value: 'reqRole', label: 'Role', searchable: false },
  { value: 'createdAt', label: 'Created Date', searchable: true },
  { value: 'status', label: 'Status', searchable: true },
  // { value: 'sailpointCaseId', label: 'Case ID', searchable: true },
  { value: 'requestorEmail', label: 'Requester', searchable: false },
  { value: 'deaNumbers', label: 'DEA Numbers', searchable: true },
  { value: 'activeApproverEmail', label: 'Subscriber Information', searchable: false },
];
